// @flow

import React from 'react';

import { Query, type QueryComponentOptions } from '@apollo/react-components';

import { type OperationVariables } from '@apollo/react-common';

export type QueryControls = OperationVariables;
export type fetchMoreType = $PropertyType<QueryControls, 'fetchMore'>;

const ApolloQuery = (props: QueryComponentOptions) => {
  // TODO: Apollo v3 has broken `ssr={false}` so if you need to use a
  // client-side only query, such as checking the name of the current user,
  // use `skip={boolean}` instead.
  if (props.ssr === false) {
    throw new Error(
      'Error! `ssr={false}` is not currently supported by ApolloQuery. Use `skip={true}` instead.'
    );
  }

  return (
    <Query {...props}>
      {(result: QueryControls) => props.children(result)}
    </Query>
  );
};

export default ApolloQuery;
